import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../utils/service";
import routeConstants from "../constants/routeConstants.json";

const BackNavigationHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleBackNavigation = (event) => {
      const token = getCookie("x-access-token");
      if (token) {
        // Prevent navigation to login if token exists
        event.preventDefault();
        navigate(routeConstants.DASHBOARD, { replace: true });
      }
    };

    window.addEventListener("popstate", handleBackNavigation);
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default BackNavigationHandler;